import React from 'react';
import { motion } from 'framer-motion';

interface SDRMetricBarProps {
  userName: string;
  value: number;
  maxValue: number;
  isTime?: boolean;
}

const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

export const SDRMetricBar: React.FC<SDRMetricBarProps> = ({ 
  userName, 
  value, 
  maxValue,
  isTime = false 
}) => {
  const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;

  return (
    <div className="py-2 2xl:py-4">
      <div className="flex justify-between items-center mb-1 2xl:mb-2">
        <span className="text-slate-300 font-medium text-lg 2xl:text-3xl truncate max-w-[220px] 2xl:max-w-[480px]">{userName}</span>
        <span className="text-slate-200 font-bold text-xl 2xl:text-4xl">
          {isTime ? formatDuration(value) : value}
        </span>
      </div>
      <div className="w-full bg-slate-700/50 rounded-full h-4 2xl:h-6 overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-slate-400 to-slate-300 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />
      </div>
    </div>
  );
};